<select2
  class="block w-full"
  [data]="receiverTypes"
  [value]="selectedType"
  [placeholder]="literalService.get('all', true)"
  (update)="onTypeChange($event)"
/>

@if (selectedType === MessageReceiver.EXPEDITION) {
  <article class="flex w-full items-center">
    <app-input
      class="w-full"
      [data]="{ id: 'filter-receiver-service', value: single(serviceList), edit: { editable: true, inputType: InputType.INFINITE_SCROLL, values: serviceList?.options, customSearchEnabled: true, placeholder: literalService.get('messages.receiver.service', true) } }"
      [edit]="true"
      [independent]="true"
      (setEventEmitter)="onServiceChange($event.value)"
      (scrollEventEmitter)="onScroll($event, serviceList)"
      (searchEventEmitter)="onSearch($event, serviceList)"
    />
  </article>
  <article class="flex w-full items-center">
    <app-input
      class="w-full"
      [data]="{ id: 'filter-receiver-route', value: single(routeList), edit: { editable: true, inputType: InputType.INFINITE_SCROLL, values: routeList?.options, customSearchEnabled: true, disabled: !routeList, placeholder: literalService.get('messages.receiver.routes', true) } }"
      [edit]="true"
      [independent]="true"
      (setEventEmitter)="onRouteChange($event.value)"
      (scrollEventEmitter)="onScroll($event, routeList)"
      (searchEventEmitter)="onSearch($event, routeList)"
    />
  </article>
  <article class="flex w-full items-center">
    <app-input
      class="w-full"
      [data]="{ id: 'filter-receiver-expedition', value: single(receiverList), edit: { editable: true, inputType: InputType.INFINITE_SCROLL, values: receiverList?.options, customSearchEnabled: true, disabled: receiverList?.disabled, placeholder: placeholder() } }"
      [edit]="true"
      [independent]="true"
      (setEventEmitter)="onExpeditionChange($event.value)"
      (scrollEventEmitter)="onScroll($event, receiverList)"
      (searchEventEmitter)="onSearch($event, receiverList)"
    />
  </article>
} @else if (selectedType) {
  <article class="flex w-full items-center">
    <app-input
      class="w-full"
      [data]="{ id: 'filter-receivers', value: receiverList?.values, edit: { editable: true, inputType: InputType.MULTISELECT_SCROLL, values: receiverList?.options, customSearchEnabled: searchable(), placeholder: placeholder() } }"
      [edit]="true"
      [independent]="true"
      (setEventEmitter)="onReceiversChange($event.value)"
      (scrollEventEmitter)="onScroll($event, receiverList)"
      (searchEventEmitter)="onSearch($event, receiverList)"
    />
  </article>
}
